module.exports = __webpack_public_path__ + "img/logo_long_white.b831bd25.png";